<template>
  <div class="paper">
    <p class="paper-item" v-for="(item, index) in data" :key="index">[{{index+1}}]<span class="kong"></span>{{item}}</p>
    <p>{{ single }}</p>
    <p>{{ fake }}</p>
    <div v-if="data.length === 0" class="nothing">
      <i class="iconfont iconkong"></i>
      <p>暂无文献</p>
    </div>
  </div>
</template>

<style lang="scss">
  @import "../assets/scss/functions";
  .paper {
    color: #000;
    padding: pxToRem(30px);
  }
  .paper a {
    color: #00a0e8;
    margin-bottom: 10px;
    display: block;
    text-decoration: none;
  }
  .kong{
    display: inline-block;
    width: 0.08rem;
  }
</style>

<script>
export default {
  props: ['data', 'single', 'fake']
}
</script>



// WEBPACK FOOTER //
// src/components/Paper.vue